module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-6 col-md-offset-3\"> <div class=\"account-balance panel\"> <label>Balance</label> <h1 class=\"balance\">")
    ; __append(escapeFn( locals.balance ))
    ; __append("</h1> <div class=\"price_per_shipment\"><span class=\"text-muted\">Plan:</span> ")
    ; __append(escapeFn( locals.price_per_shipment ))
    ; __append(" cents/label</div> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/account_balance.ejs
// module id = 862
// module chunks = 1